export default class LDGridMoreCourses {
    constructor() {
        this.blockGrids = [...document.querySelectorAll('.jsBlockGrid')];

        if (this.blockGrids.length) {
            this.blockMoreBtns = [
                ...document.querySelectorAll('.jsBlockMoreBtn'),
            ];

            this.events();
        }
    }

    events() {
        if (this.blockMoreBtns.length) {
            this.blockMoreBtns.forEach((btn) =>
                btn.addEventListener('click', this.showMoreCourses.bind(this)),
            );
        }
    }

    showMoreCourses(e) {
        const clickedBtn = e.currentTarget;

        if (!clickedBtn) return;

        const blockGridTarget = clickedBtn.dataset.gridCat;

        const filteredBlockGrid = this.blockGrids.filter(
            (block) => block.dataset.gridCat === blockGridTarget,
        );

        if (!filteredBlockGrid.length) return;

        const blockGridToChange = filteredBlockGrid[0];

        const blockItemsCount = parseInt(
            blockGridToChange.dataset.itemsCount,
            10,
        );
        const blockItemsVisible = parseInt(
            blockGridToChange.dataset.itemsVisible,
            10,
        );
        const blockItemsReveal = parseInt(
            blockGridToChange.dataset.itemsReveal,
            10,
        );

        const newBlockItemsVisible =
            blockItemsVisible + blockItemsReveal < blockItemsCount
                ? blockItemsVisible + blockItemsReveal
                : blockItemsCount;

        const blockGridItems = [
            ...blockGridToChange.querySelectorAll('.jsBlockGridItem'),
        ];

        blockGridToChange.dataset.itemsVisible = newBlockItemsVisible;

        blockGridItems.forEach((item) => {
            const itemNumber = parseInt(item.dataset.itemNumber, 10);
            if (itemNumber <= newBlockItemsVisible)
                item.classList.remove('is-hidden');
        });

        if (newBlockItemsVisible >= blockItemsCount) {
            clickedBtn.remove();
        }
    }
}
